/* istanbul ignore file */

import './index.scss';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import App from './App';
import ListerStore from './store/lister-store';

ReactDOM.render(
	<Provider store={ListerStore}>
		<App />
	</Provider>,
	document.getElementById('app')
);
